import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';
import styles from './SearchBar.module.scss';
import { useNavigate } from 'react-router-dom';

export default function SearchBar(props) {
    const { offcanvas } = props;
    const [searchText, setSearchText] = useState('');
    const navigate = useNavigate(); // Utiliza useNavigate para la navegación

    const handleInputChange = (e) => {
        //console.log(e.target.value);
        setSearchText(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const encodedSearchText = encodeURIComponent(searchText);
        const absoluteURL = `/search/?keywords=${encodedSearchText}`;
        window.location.href = absoluteURL;
    };

    const handleIconClick = () => {
        // Crea un objeto falso para evitar errores en handleSubmit
        handleSubmit({ preventDefault: () => {} });
    };
    return (
        <Form onSubmit={handleSubmit} className={`${styles.search} d-flex`}>
            <InputGroup className={`${styles.inputGroup}`}>
                <Form.Control
                    type="search"
                    placeholder={`Search`}
                    className={`${styles.input} me-5`}
                    aria-label="Search"
                    value={searchText}
                    onChange={handleInputChange}
                />
                <InputGroup.Text
                    id="basic-addon1"
                    className={`${styles.icon}`}
                    onClick={handleIconClick}
                    style={{ cursor: 'pointer' }}
                >
                    <Search />
                </InputGroup.Text>
            </InputGroup>
        </Form>
    )
}
